import React from "react";
import owner from "../assets/Owner/owner.jpeg";
import uncle from "../assets/Owner/uncle.jpeg";

export default function Owner() {
  return (
    <section
      id="owner"
      className="relative py-16 sm:py-20 md:py-28 bg-gradient-to-br from-maroon-dark via-maroon to-maroon-dark text-white overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.08]">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern
              id="ownerPattern"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="20" cy="20" r="1.5" fill="#c9a227" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#ownerPattern)" />
        </svg>
      </div>

      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-gold/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold font-semibold mb-4">
            <span className="h-px w-8 bg-gold" />
            Meet The Visionaries
            <span className="h-px w-8 bg-gold" />
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-white">
            The Hands That{" "}
            <span className="gold-gradient-text">Carry The Legacy</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-sm sm:text-base text-white/80 leading-relaxed">
            Two generations, one shared promise. The 4th and 5th custodians of
            our 90-year-old craft, working side by side to honour the past and
            shape the future.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-2 grid grid-cols-2 gap-4 sm:gap-5 max-w-md mx-auto lg:max-w-none">
            <PortraitCard
              src={uncle}
              name="Shiv Kumar Soni"
              role="4th Generation"
              tag="The Master  Since 1998"
            />
            <PortraitCard
              src={owner}
              name="Viraj Soni"
              role="5th Generation"
              tag="Owner & Creative Director"
              highlight
            />
          </div>

          <div className="lg:col-span-3">
            <div className="mt-2 sm:mt-4 relative">
              <svg
                className="absolute -top-2 -left-2 w-10 h-10 text-gold/30"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z" />
              </svg>

              <p className="relative pl-10 text-base sm:text-lg text-white/90 leading-relaxed italic font-light">
                For us, jewellery is not just metal and stone  it is memory,
                legacy, and love made eternal. As the fifth generation of this
                cherished family, my role is to honour the craft of my
                forefathers while carrying its soul into tomorrow. Every piece
                that leaves our showroom carries nine decades of trust and
                the promise of a story yet to be written.
              </p>
              <p className="relative pl-10 mt-4 text-sm text-gold font-semibold uppercase tracking-[0.25em]">
                 Viraj Soni, 5th Generation
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:items-center">
              <a
                href="#visit"
                className="inline-flex items-center gap-2 bg-gold text-maroon px-6 py-3 rounded-full font-semibold text-sm hover:bg-gold-light transition-colors shadow-lg self-start"
              >
                Visit Our Showroom
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 border-2 border-gold/60 text-gold px-6 py-3 rounded-full font-semibold text-sm hover:bg-gold/10 transition-colors self-start"
              >
                Read Our Story
              </a>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              <MiniStat number="1933" label="Established" />
              <MiniStat number="5" label="Generations" />
              <MiniStat number="90+" label="Years of Legacy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function PortraitCard({ src, name, role, tag, highlight }) {
  return (
    <div className="relative group">
      <div
        className={`absolute inset-0 rounded-3xl blur-xl scale-105 transition-opacity ${
          highlight
            ? "bg-gradient-to-br from-gold/40 to-transparent opacity-100"
            : "bg-gradient-to-br from-gold/20 to-transparent opacity-60 group-hover:opacity-100"
        }`}
      />
      <div
        className={`relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border-4 ${
          highlight ? "border-gold" : "border-gold/40"
        }`}
      >
        <img
          src={src}
          alt={`${name}  ${role}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent p-3 sm:p-4 pt-8 sm:pt-10">
          <div className="text-[8px] sm:text-[10px] uppercase tracking-[0.3em] text-white font-bold mb-1">
            {role}
          </div>
          <div className="font-serif text-sm sm:text-base lg:text-lg font-bold text-white leading-tight">
            {name}
          </div>
          <div className="text-[10px] sm:text-xs text-white/75 mt-0.5 leading-tight">
            {tag}
          </div>
        </div>
      </div>
    </div>
  );
}

function MiniStat({ number, label }) {
  return (
    <div className="border-l-2 border-gold/50 pl-3">
      <div className="font-serif text-xl sm:text-2xl font-bold text-gold">
        {number}
      </div>
      <div className="text-[10px] sm:text-xs uppercase tracking-wider text-white/70 mt-1">
        {label}
      </div>
    </div>
  );
}
